<script setup lang="ts">
import {computed } from "vue";
import MacLogo from "@/views/pages/main/MacLogo.vue";
const props = defineProps({
  logoColor: {
    type: String,
    default: '#ffffff'
  },
  year: {
    type: Number || String,
    default: 2023
  }
})

const logoColor = computed(() => props.logoColor ? props.logoColor : '#ffffff')
const year = computed(() => props.year ? props.year : 2023)
</script>

<template>
  <a class="bps-banner"
     target="_blank"
     href="https://partnerkin.com/mac24">
    <div class="bps-banner--logo-cc">
      <MacLogo :height="38" :color="logoColor" :mask-color="logoColor" />
    </div>
    <div class="bps-banner--desc">
      <span class="title">
        <span class="title--header">{{$t('title')}}</span>
        <i18n tag="span" class="title--year" path="of the year {year}">
            <template #year>{{ year }}</template>
        </i18n>
      </span>
    </div>
  </a>
</template>

<style scoped lang="less">
@import "bps-banner";

.bps-banner {
  //min-width: 280px;
  .bps-banner--logo-cc {
    //height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

<i18n>
{
  "ru": {
    "of the year {year}": "{year}",
    "title": "Лучший финансовый сервис"
  },
  "en": {
    "of the year {year}": "of the Year {year}",
    "title": "Best Financial Service"
  }
}
</i18n>
